// Cache API responses
import jwtDecode from "jwt-decode";

const lsCache = localStorage.getItem('APICache');
let APICache = JSON.parse(lsCache) || {};

export function getAPICache(...keys) {
    const token = localStorage.getItem("clientJWT");
    const {userId} = jwtDecode(token);
    return APICache[userId] && APICache[userId][JSON.stringify(keys)];
}

export function setAPICache(response, ...keys) {
    const token = localStorage.getItem("clientJWT");
    const {userId} = jwtDecode(token);

    APICache[userId] = APICache[userId] || {};
    APICache[userId][JSON.stringify(keys)] = response;
    localStorage.setItem('APICache', JSON.stringify(APICache));
}

export function nuclearAPICache() {
    APICache = {};
    localStorage.setItem('APICache', JSON.stringify(APICache));
}

export function deleteAPICache(...keys) {
    const token = localStorage.getItem("clientJWT");
    const { userId } = jwtDecode(token);
    // If keys are provided, delete the specific cache entry
    if (keys.length > 0) {
        if (APICache[userId] && APICache[userId][JSON.stringify(keys)]) {
            delete APICache[userId][JSON.stringify(keys)];
        }
    } else {
        delete APICache[userId];
    }
    localStorage.setItem('APICache', JSON.stringify(APICache));

}